module.exports = "dist/d659209138fc7c28c23a48496bdd1c8b.svg";